import { createFileRoute } from "@tanstack/react-router";
import EmailSettingsPage from "@/site/pages/email-settings";

// Old app's email settings lived at /email_settings — keep the URL (PRD 08 §6.1).
export const Route = createFileRoute("/email_settings")({
  component: EmailSettingsPage,
});
